<template>
  <div>
    <GmapMap
      style="height: 100%"
      :zoom="zoomLevel"
      :center="center"
      :options="{
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: true,
        rotateControl: true,
        fullscreenControl: true,
        disableDefaultUI: false,
      }"
      @zoom_changed="zoomed"
    >
      <template v-if="locationType == 'state'">
        <GmapCircle
          v-for="(pin, index) in radiusMarkers"
          :key="index"
          :center="pin.position"
          :radius="pin.radius"
          :visible="true"
          :options="pin.options"
          @click="openInfoWindowTemplate(pin)"
        ></GmapCircle>
      </template>
      <template v-else>
        <GmapMarker
          v-for="(pin, index) in radiusMarkers"
          :key="index"
          :position="pin.position"
          :visible="true"
          :options="pin.options"
          @click="openInfoWindowTemplate(pin)"
        ></GmapMarker>
      </template>
      <gmap-info-window
        :options="{
          maxWidth: 300,
          pixelOffset: { width: 0, height: -35 },
        }"
        :position="infoWindow.position"
        :opened="infoWindow.open"
        @closeclick="infoWindow.open = false"
      >
        <!-- <div v-html="infoWindow.template"></div> -->
        <oil-info
          :detail="well"
          v-if="well"
          :key="well.id"
          @zoomed="zoomInto"
        />
        <detail />
      </gmap-info-window>
    </GmapMap>
    <oil-filter v-if="showFilter" />
  </div>
</template>

<script>
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
// import ApiService from "@/services/api.service";

import { createNamespacedHelpers } from "vuex";
// import { getLocations } from "./lib/api";

const oilNamespace = createNamespacedHelpers("oil");

import oil from "@/store/modules/oil";

const defaultZoomLevel = 6.3;

const chartNamespace = createNamespacedHelpers("charts");

const OilInfo = () => import("@/components/charts/oil/info.vue");
const OilFilter = () => import("@/components/charts/oil/filter.vue");
const Detail = () => import("@/components/charts/oil/detail.vue");

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyB-7U65LZ6XpNGbQUHuwxJlt-hZq2F3C0w",
    libraries: "places", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,
});
// 9.459174,8.7693426,6.87z
// 9.0242494,7.3798281
export default {
  props: ["chart"],
  data() {
    return {
      markers: [],
      lastLocationType: null,
      place: null,
      center: { lat: 9.0242494, lng: 7.3798281 },
      list: [],
      locations: [],
      // radiusMarkers: [],
      zoomLevel: defaultZoomLevel,
      infoWindow: {
        position: { lat: 0, lng: 0 },
        open: false,
        template: "",
      },
      well: null,
    };
  },
  computed: {
    // ...dataSourceNamespace.mapState(['dataSources']),
    ...oilNamespace.mapState({
      radiusMarkers: (state) => state.radiusMarkers,
      locationType: (state) => state.locationType,
      loaded: (state) => state.loaded,
      loading: (state) => state.loading,
    }),
  },
  components: {
    OilInfo,
    OilFilter,
    Detail,
  },
  methods: {
    ...oilNamespace.mapActions([
      "aLoadLocations",
    ]),
    ...oilNamespace.mapMutations([
      "mSetMappedLocations",
      "mSetRadiusMarkers",
      "mSetZoomLevel",
    ]),
    ...chartNamespace.mapActions(["aSetSubChart"]),
    async start() {
      if (!this.loaded) {
        await this.aLoadLocations();
      }
      this.loadLocations();
    },
    openInfoWindowTemplate(pin) {
      const { name, position, productionPercent, description } = pin;
      const { lat, lng } = position;
      this.infoWindow.position = { lat: lat, lng: lng };
      this.infoWindow.template = `<b>${name}</b><br>${description}<br>${name} ${productionPercent}%<br>`;
      this.infoWindow.open = true;
      this.well = { ...pin };
    },
    setDescription(description) {
      this.description = description;
    },
    zoomInto(params) {
      this.center = params.center;
      this.zoomed(params.zoomLevel);
    },
    zoomed(zoomLevel) {
      if (zoomLevel != this.zoomLevel) {
        this.zoomLevel = zoomLevel;
      }
      // this.locationType = zoomLevel >= 8 ? 'well' : 'state';
      this.mSetZoomLevel(zoomLevel);
      this.mSetRadiusMarkers();
      // console.log("zoomLevel", zoomLevel);
    },
    setPlace(place) {
      this.place = place;
    },
    usePlace() {
      if (this.place) {
        this.markers.push({
          position: {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng(),
          },
        });
        this.place = null;
      }
    },
    clicked(marker) {
      this.center = marker.position;
      this.aSetSubChart({ chart: this.chart, item: {} });
    },
    async loadLocations() {
      this.mSetMappedLocations();
      this.mSetRadiusMarkers();
    },
    setRadiusMarkers() {
      // console.log('setRadiusMarkers');
      const locationType = this.locationType;
      if (this.lastLocationType == locationType && this.radiusMarkers.length) {
        return true;
      }
      let markers = this.locations.filter((item) => item.type === locationType);
      this.radiusMarkers = [...markers];
      this.lastLocationType = locationType;
    },
  },
  beforeCreate: function () {
    if (typeof this.$store.state["oil"] == "undefined") {
      this.$store.registerModule("oil", oil);
    }
  },
  mounted() {
    this.start();
    if(!this.chart) {
      this.showFilter = true;
    }
  },
};
</script>
